import React, { useContext } from 'react';
import {
  Grid,
  Autocomplete,
  TextField,
  Checkbox,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ProjectContext } from '../../../Contexts/Project/Context';
import ContentNotFound from "./ContentNotFound";
import { useQuery } from '@apollo/client/react';
import { GetCompanyContractTypesDocument } from '@/graphql/generated/graphql';
import { arrayLength } from '@/utils/helperFunctions';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ContractTypes: React.FC = () => {
  const { onContractChange, project } = useContext(ProjectContext);
  const selectedContracts = project.contractTypeIds || [];
  const { data, loading } = useQuery(GetCompanyContractTypesDocument);

  if (!loading && arrayLength(data?.getCompanyContractTypes) === 0) return (
    <ContentNotFound
      title="No contracts found"
      subtitle="To add supported contracts to a project, please activate them in Company Settings."
    />
  );

  return (
    <Grid container spacing={2} mt={1}>
      <Grid size={12}>
        <Autocomplete
          multiple
          disableCloseOnSelect
          id="contract-types-selector"
          loading={loading}
          options={data?.getCompanyContractTypes || []}
          value={data?.getCompanyContractTypes?.filter(
            contract => selectedContracts.includes(contract.contractTypeId as string)
          ) || []}
          onChange={(_, newValue) => {
            onContractChange(newValue.map(contract => contract.contractTypeId as string));
          }}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option, { selected }) => (
            <li {...props} key={`selectedContracts-${option.id}`} >
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Contract Types"
              placeholder="Select contract types"
            />
          )}
          isOptionEqualToValue={(option, value) =>
            option.contractTypeId === value.contractTypeId
          }
        />
      </Grid>
    </Grid>
  );
};

export default ContractTypes;
